/**
 * formatUtils.js — Number / currency formatters shared across the app.
 */

/** Format a number as a dollar string: "$12.34" */
export const fmt$ = v => `$${parseFloat(v || 0).toFixed(2)}`;

/** Format a number with locale-appropriate thousands separators. */
export const fmtN = v => (v || 0).toLocaleString();

/** Return "XX.X%" of a over b, or "0%" when b is zero. */
export function pct(a, b) {
  return b ? ((a / b) * 100).toFixed(1) + '%' : '0%';
}

/**
 * Format a phone number for display: E.164 "+14794129916" or any raw digits
 * → "(479) 412-9916". Falls back to the original string when it isn't a
 * recognizable 10/11-digit US number (never hides an unusual number).
 */
export function fmtPhone(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (ten.length !== 10) return raw || '';
  return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
}

/** tel: href for a phone number — strips formatting, keeps a leading "+". */
export function telHref(raw) {
  const s = String(raw || '');
  const plus = s.trim().startsWith('+') ? '+' : '';
  return `tel:${plus}${s.replace(/\D/g, '')}`;
}
